import { Options, Vue } from 'vue-class-component';
import Toggle from '@vueform/toggle';

import * as ProductTypeService from '@/services/product-type.service';
import { IProductType } from '@/domain/product-type.model';

@Options({
  name: 'product-type-edit',
  props: {
    id: String,
  },
  components: {
    Toggle,
  },
})
export default class ProductTypeNew extends Vue {
  public id: string;
  public errorMessage = '';
  public errors: any = {};
  public hasError = false;
  public row: IProductType = {
    description: '',
    enabled: false,
  };

  public mounted(): void {
    ProductTypeService.get(this.id)
      .then((res: IProductType) => {
        if (res && res.id) {
          this.row = res;
        } else {
          this.errorMessage = 'Registro não encontrado.';
        }
      })
      .catch(() => {
        this.errorMessage = 'Registro não encontrado.';
      });
  }

  public goBack() {
    this.$router.push('/product-type');
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    if (!this.row.description) {
      this.errors.description = 'Este campo deve ser preenchido.';
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      ProductTypeService.update({
        id: parseInt(this.id),
        description: this.row.description,
        enabled: this.row.enabled,
      })
        .then(() => {
          this.$router.push('/product-type');
        })
        .catch(() => {
          this.errorMessage = 'Ocorreu um erro ao gravar o registro.';
        });
    }
  }
}
